import React, {FC} from 'react';

import QuestionCardCheckbox from '../../components/QuestionCardCheckbox';
import {INSURANCE_OPTIONS} from '../../constants';

const StepInsurance: FC = () => (
  <QuestionCardCheckbox field="insurance" options={INSURANCE_OPTIONS} />
);

export default StepInsurance;
